import React from 'react';
import { TextField } from 'mui-rff';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
//
import { maxLength } from 'utils/validate';

const notesMaxLength = maxLength(255);
const internalNotesMaxLength = maxLength(5_000);

export const createFormFields = (values, isUpdate, disabled) => {
  return [
    {
      size: 6,
      isCopy: true,
      name: 'name',
      field: (
        <TextField
          id='name'
          name='name'
          label='Name'
          fullWidth
          required
          disabled={disabled}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          name='note'
          multiline
          label='Notes'
          margin='none'
          disabled={disabled}
          fieldProps={{
            validate: notesMaxLength,
          }}
        />
      ),
    },
    {
      size: 12,
      name: 'internalNotes',
      field: (
        <TextField
          name='internalNotes'
          multiline
          label='Private Notes'
          margin='none'
          disabled={disabled}
          fieldProps={{
            validate: internalNotesMaxLength,
          }}
        />
      ),
    },
  ];
};

export const IntegrationTypeRadioControls = ({ input, disabled, ...rest }) => {
  return (
    <FormControl disabled={disabled}>
      <FormLabel id='integrationType'>Integration Type</FormLabel>
      <RadioGroup
        {...rest}
        row
        name={input.name}
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel
          value={false}
          control={<Radio />}
          label='Manual Integration'
        />
        <FormControlLabel value control={<Radio />} label='Gateway' />
      </RadioGroup>
    </FormControl>
  );
};

export const PaymentTypeRadioControls = ({ input, disabled, ...rest }) => {
  return (
    <FormControl disabled={disabled}>
      <FormLabel id='paymentType'>Payment Type</FormLabel>
      <RadioGroup
        {...rest}
        row
        name={input.name}
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='PREPAY' control={<Radio />} label='Prepay' />
        <FormControlLabel value='POSTPAY' control={<Radio />} label='Postpay' />
      </RadioGroup>
    </FormControl>
  );
};
